import { useEffect, useMemo, useState } from 'react'
import GetApi from '../../common/api/get'

const useDisinfectionMeasures = () => {
  const [ disinfectionMeasures, setDisinfectionMeasures ] = useState([])
  const [ isLoading, setIsLoading ] = useState(false)
  const [ isError, setIsError ] = useState(false)

  useEffect(() => {
    const call = async () => {
      setIsLoading(true)

      try {
        const { body } = await new GetApi().execute(routeUrlHelper.classificationsDisinfectionMeasuresPath())
        setDisinfectionMeasures(body)
      } catch(err) {
        setIsError(err)
      }

      setIsLoading(false)
    }

    call()
  }, [])

  const categories = useMemo(() =>
    disinfectionMeasures.reduce((categories, measure) => {
      categories[measure.category] = categories[measure.category] || []
      categories[measure.category].push(measure)
      return categories
    }, {}),
  [disinfectionMeasures])

  return [{ disinfectionMeasures, categories, isLoading, isError }]
}

export default useDisinfectionMeasures
